import * as bindings from '../../authorizationBindings';
import { createAsyncAppThunk } from '../createAsyncAppThunk';
import { AuthorizeResult } from './authorizeResult';

export const refreshAuthorization = createAsyncAppThunk<void, AuthorizeResult>(
    'auth/refresh',
    async (_, thunkApi) => {
        const projectId = thunkApi.getState().auth.id!;
        return {
            jwt: await bindings.refreshAuthorization(projectId)
        };
    }
);